import { useQuery } from '@tanstack/react-query';
import { getMemberInvitationOptions } from '@/api';
import { useSearch } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

function InvitationInfo() {
  const { token } = useSearch({ from: '/register' });
  const { data: invitation } = useQuery({
    ...getMemberInvitationOptions({
      query: {
        token: token || '',
      },
    }),
    enabled: !!token
  }
  );

  if (!invitation) {
    return null;
  }

  return (
    <div className="flex items-center gap-3 p-3 mb-4 rounded-sm bg-gray-50 dark:bg-gray-900">
      {invitation.company.profile_image ? (
        <img
          src={invitation.company.profile_image}
          alt={invitation.company.name}
          className="w-10 h-10 rounded-sm object-cover"
        />
      ) : (
        <div className="w-10 h-10 rounded-sm bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
          <Building2 className="w-5 h-5 text-gray-500 dark:text-gray-400" />
        </div>
      )}
      <div>
        <p className="text-sm font-medium">{invitation.company.name}</p>
        <p className="text-xs text-muted-foreground">Invited you to join</p>
      </div>
    </div>
  );
}

export default InvitationInfo;
